






















































































































































import mixins from 'vue-typed-mixins';
import { SurveyState } from '@/utils/SurveyUtils';
import cloneDeep from 'lodash.clonedeep';
import EmailUtils, { AutomatedEmail } from '../../../utils/EmailUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => SurveyState,
    },
    states: {
      type: Array as () => SurveyState[],
    },
  },

  computed: {
    stateOptions(): any {
      return this.states
        ?.map((state) => ({
          text: state.key,
          value: state,
        }))
        .filter((item) => item.value.id !== this.value.id);
    },

    emailsOptions(): any {
      return this.emails?.map((email) => ({
        text: email.name,
        value: email.key,
      }));
    },

    categories(): SurveyState['category'][] {
      return ['NOT STARTED', 'NOT SUBMITTED', 'SUBMITTED', 'COMPLETE'];
    },
  },

  data(): {
    emails?: AutomatedEmail[];
  } {
    return {
      emails: undefined,
    };
  },

  async mounted() {
    this.value.nextstate.serviceprovider = this.value.nextstate.serviceprovider
      .map(
        (state) =>
          this.stateOptions.find((item: any) => item.value.key === state.key)
            ?.value
      )
      .filter((state) => !!state);
    this.value.nextstate.oversight = this.value.nextstate.oversight
      .map(
        (state) =>
          this.stateOptions.find((item: any) => item.value.key === state.key)
            ?.value
      )
      .filter((state) => !!state);

    try {
      this.emails = (await EmailUtils.api.list()).filter(
        (email) => email.type === 'survey'
      );
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },
});
